<template>
        <div>

    <loading-full v-if="!order && error==false" :status="statusmessage"/>

        <div v-if="this.error" class='alert alert-danger'>
                 {{ this.error }}
        </div>

    <div v-if="eventLoaded=='loaded'" class='container  mb-5'>    
        <event-info v-if="allinfos" class="pt-5 mt-5" :event="event"></event-info>

        <div v-if="order " >

                <div v-if='order.paymentStatus=="waiting" && order._paymentType=="credit"' class="alert alert-warning">
                        <h4> Sua compra esta sendo Processada!</h4>
                        <p>Seu pedido foi recebido em nosso sistema e está sendo processado. </p>
                        <p>De modo geral, ocorre em até no máximo 2 dias úteis. </p>
                        <p>Por favor aguardar a Confirmação de seu Pagamento e demais informações na Área do Cliente e/ou via E-mail. </p>
                        <p>A qualquer momento você pode acessar <a :href='orderstatuslink'>{{orderstatuslink}}</a> para verificar o status do seu pagamento! </p>
                        <p><b> Para realizar uma nova tentativa de pagamento, clique no botão abaixo:<br/><router-link class="btn btn-primary" :to="`/event/${order.eventId}/${order.token}`"> Novo pagamento </router-link> </b></p>
                </div>


                 <div v-if='order.paymentStatus=="waiting" && order._paymentType=="boleto"' class="alert alert-warning">
                        <h4> Obrigado! Agora só falta pagar o boleto para finalizar seu pedido!</h4>
                        <h4> <a target="_blank" :href="order._paymentLink" class="btn btn-lg btn-primary"> Imprimir Boleto </a> </h4>
                        <p>Se seu boleto ja foi pago, aguarde o seu processamento, ocorre em até no máximo 3 dias úteis. </p>
                        <p>Por favor aguardar a Confirmação de seu Pagamento e demais informações na Área do Cliente e/ou via E-mail. </p>
                        <p>A qualquer momento você pode acessar <a :href='orderstatuslink'>{{orderstatuslink}}</a> para verificar o status do seu pagamento! </p>
                        <p><b> Para realizar uma nova tentativa de pagamento, clique no botão abaixo:<br/><router-link class="btn btn-primary" :to="`/event/${order.eventId}/${order.token}`"> Novo pagamento </router-link> </b></p>
                </div>


                <div v-if='order.paymentStatus=="error"' class="alert alert-danger">
                        <h4> Ocorreu um erro no seu pagamento! Tente Novamente</h4>
                </div>
                <div v-if='order.paymentStatus=="canceled"' class="alert alert-danger">
                        <h4> Seu pagamento não foi autorizado ou cancelado! Tente Novamente acessando <router-link :to="`/event/${order.eventId}/${order.token}`"> aqui! </router-link>  </h4>
                </div>
        
                <div v-if='order.paymentStatus=="payed"' class="alert alert-success">
                        <h4> Obrigado pela sua compra! O pagamento foi efetuado com sucesso! </h4>
                </div>

                <div  v-if="allinfos">
                        <h3 class='mt-5'> Minhas Inscrições </h3>
                        <hr/>
                        <purshase-products-list ref='purchaseProductList'> </purshase-products-list>
                        <a @click="saveMyPurshaseInfos"  class='btn btn-lg btn-primary' style="color:white"> Salvar Alterações </a>
                </div>
                
                
                <!-- <router-link :to="`/event/${order.eventId}/${order.token}`"> Realizar novo pagamento! </router-link>  -->
                <!-- <h3 class='mt-5'> Detalhes da compra </h3>
                <hr/>
                <order-detail class='mt' :order="order" /> -->
              
        </div>
        </div>
       
    </div>

</template>

<script>
import validadeFormMixins from "@/mixins/validateForms"
export default {
    mixins:[validadeFormMixins],
    data(){
            return {
                    error:false,
                    loaded:false,
                    statusmessage:''
            }
    },
    props:{
            'orderid':{},
            'allinfos':{default:true},
    },
        
    created:async function(){
        let token = this.orderid;
        this.loadOrder(token)
    },

    watch:{
            orderid:function(){
                let token = this.orderid;
                this.loadOrder(token)
            }
    },
    
//     beforeRouteUpdate (to, from, next) {
//         let token = to.params.order;
//         this.loadOrder(token)
//         next()
//     },

    computed:{

        order:function(){
                return this.$store.getters['OrderStore/currentOrder'];
        },
        orderstatuslink:function(){
            return window.location.href;
        },

        event:function(){
                return this.$store.getters['EventStore/eventInfo'];
        },
        eventLoaded:function(){
                return this.$store.getters['EventStore/status'];
        },
    },
    methods:{

        loadOrder:async function(token){
                this.statusmessage = "Carregando status da sua compra..."
                let res = await this.$store.dispatch('OrderStore/loadOrderByToken', token ) 
                if(res){
                        this.loaded = true
                }else{
                        this.error = "Erro a carregar a ordem. Recarregua a página ou entre em contato com o administrador!"
                }
        },

        saveMyPurshaseInfos:async function(){
           var formValid = await this.validateForms(); 
           var response = await this.$store.dispatch('OrderStore/saveOrder')
           let order = response.order;
                
                //erro para salvar a order   
                if(response.error){ 
                    this.error = response.msg;
                //     this.processing = false;
                    return false;
                
                }

                window.location.reload();

                return true
        }
    }
}
</script>